import type { ModuleId } from '@tahi/core';
import { Navigate, useParams } from 'react-router';
import { useModuleStates, useUsableModules } from '../data/hooks';
import { getWebModule } from '../modules/registry';

export function ModuleRoute() {
  const { moduleId } = useParams();
  const usable = useUsableModules();
  const { data: states } = useModuleStates();
  const def = moduleId ? getWebModule(moduleId as ModuleId) : undefined;
  if (!def) return <Navigate to="/modules" replace />;
  if (states === undefined) return null; // still reading module_states
  if (!usable[def.id]) return <Navigate to="/modules" replace />;
  const Screen = def.Screen;
  return <Screen />;
}
